import styled from 'styled-components';
import { colors } from 'globalStyles';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 10em;
  min-height: 10em;
  background-color: ${colors.WHITE};
  border: 1px solid rgba(0,0,0,0.2);
  border-radius: 0.25em;
`;

export const StyledSlider = styled.div`
  position: absolute;
  top: 1em;
  bottom: 1em;
  right: 0;
  padding-right: 2em;
  width: 10px;
  cursor: pointer;
`;

export const Track = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  width: 8px;
  margin-left: -4px;
  border-radius: 3px;
  background: linear-gradient(to bottom,
    #FF0000 0%,
    #FF0099 10%,
    #CD00FF 20%,
    #3200FF 30%,
    #0066FF 40%,
    #00FFFD 50%,
    #00FF66 60%,
    #35FF00 70%,
    #CDFF00 80%,
    #FF9900 90%,
    #FF0000 100%
  );
`;

export const StyledColorMap = styled.div`
  position: absolute;
  top: 1em;
  bottom: 1em;
  right: 2em;
  left: 1em;
  overflow: hidden;
  user-select: none;
  border-radius: 0.25em;
  cursor: pointer;
`;

export const Background = styled.div`
  top: 0;
  left: 0;
  position: absolute;
  height: 100%;
  width: 100%;

  &:before,
  &:after {
    display: block;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  &:after {
    background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,1) 100%);
  }

  &:before {
    background: linear-gradient(to right, rgba(255,255,255,1) 0%,rgba(255,255,255,0) 100%);
  }
`;

export const Pointer = styled.div`
  position: absolute;
  width: 10px;
  height: 10px;
  margin-left: -5px;
  margin-bottom: -5px;
  border-radius: 100%;
  background-color: ${colors.WHITE};
`;



// WEBPACK FOOTER //
// ./src/components/ColorPicker/styledComponents.js